import { Button, Col, Image, Modal, Progress, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { strings } from "@utils/Strings";
import Session from "@assets/SVG/session.svg";
import Success from "@assets/SVG/thanking-vector.svg";

import styles from "./LoaderModal.module.scss";
import { post } from "~/Services";

interface LoaderModalProps {
  isOpenModal: boolean;
  totalFiles: any;
  filesUploadCount: any;
  redirect: string;
  retrigger?: any;
  isRearrangeable?: boolean;
  envelopeId?: any;
  openNotification?:any
}

const { Text } = Typography;

export const LoaderModal: React.FC<LoaderModalProps> = ({openNotification, isOpenModal, totalFiles, filesUploadCount, redirect, retrigger, isRearrangeable, envelopeId }) => {

   const navigate = useNavigate()
   const percent = Math.round((filesUploadCount / totalFiles) * 100);
  const [loadingRedirect, setLoadingRedirect] = useState<boolean>();


  const handleRedirect = async () =>{
    setLoadingRedirect(true)
    const formData = new FormData();
    formData.append("envelopeId", envelopeId);
    formData.append("returnUrl", redirect);
    post("v1/clm/createConsoleView?action=rearrange", formData)
      .then((res: any) => {
        setLoadingRedirect(false)
        window.location.replace(res?.response?.data);
      })
      .catch((err) => {
        setLoadingRedirect(false)
      });
  }

  return (
    <Modal
      open={isOpenModal}
      maskClosable={false}
      centered
      closable={false}
      footer={null}
    >
      <Row
        style={{ marginTop: 10 }}
        justify="center"
      >
        <Col>
          <Typography.Title level={3}>{filesUploadCount == totalFiles ? "File Upload Completed" : "File Upload in Progress"}</Typography.Title>
        </Col>
      </Row>
      <Row
        style={{ marginTop: 20 }}
        justify="center"
      >
        <Col>
          <Image
            src={filesUploadCount == totalFiles ? Success : Session}
            preview={false}
            className={filesUploadCount == totalFiles ? "" : "spinning-image"}
          />
        </Col>
      </Row>
      <Row
        justify="center"
        style={{ marginTop: 30 }}
      >
        <Col style={{ textAlign: "center" }}>
          <h3 style={{ fontWeight: "bold", paddingBottom: 5 }}>{filesUploadCount == totalFiles ? strings.fileUploadedMessage : strings.fileUploadingMessage}</h3>
          <h3 style={{ fontWeight: "bold", paddingBottom: 5 }}>{filesUploadCount == totalFiles  && isRearrangeable ? "Please click on Re-Arrange to Order the files in DocuSign" : ""}</h3>
        </Col>
      </Row>
      <Progress
        style={{ marginTop: 20 }}
        percent={percent}
        strokeWidth={10}
        status="active"
        strokeColor={{ from: styles.primary, to: styles.secondary }}
      />
      <Row
        justify="center"
        style={{ marginTop: 20, gap: 10 }}
      >
        <Col>
          <Button
            type="primary"
            disabled={filesUploadCount != totalFiles}
            onClick={() => {
              if(isRearrangeable) {
                window.location.replace(redirect);
              }else {
                navigate(redirect)
                retrigger((prevState: any) => !prevState);
              }
            }}
          >
            Go Back
          </Button>
        </Col>
        {isRearrangeable && <Col>
          <Button
            type="primary"
            disabled={filesUploadCount != totalFiles}
            loading={loadingRedirect}
            onClick={() => {
              if (isRearrangeable) {
                handleRedirect();
              }
            }}
          >
            Re-Arrange Files
          </Button>
        </Col>}
      </Row>
    </Modal>
  );
};
